export default {"src":"/_next/static/media/tech.2e0ba809.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};